export default class StructuralEngineerRepo {
	constructor({ sbTo, supabaseClientFactory, _ }) {
		this.sbTo = sbTo;
		this._ = _;
		this.supabase = supabaseClientFactory;
	}

	async getAllEngineers() {
		const [err, response] = await this.sbTo(this.supabase.from('structural_engineer').select());
		if (err) {
			throw err;
		} else {
			return response;
		}
	}

	async upsertEngineer(eng) {
		if (!eng) {
			throw new Error('Engineer required to upsert.');
		}
		const [err, response] = await this.sbTo(this.supabase
			.from('structural_engineer')
			.upsert(eng, { onConflict: 'name' }));
		if (err) {
			throw err;
		} else {
			return this._.get(response, '[0]', null);
		}
	}
}
